exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* OLD */\n", ""]);

// exports
exports.locals = {
	"contentWidth": "1240px",
	"minContentHeight": "768px",
	"sidebarWidth": "260px",
	"sidebarCollapsedWidth": "80px",
	"mainFontFamily": "'proxima-nova', 'Helvetica Neue', helvetica, arial, sans-serif",
	"secondaryFontFamily": "'Soleil', 'Helvetica Neue', helvetica, arial, sans-serif",
	"settingsFontFamily": "'Work Sans', 'Helvetica Neue', helvetica, arial, sans-serif",
	"minimumContentPadding": "16px",
	"mediumWidth": "768px",
	"tileWidth": "calc(768px - (16px * 2))",
	"borderRadius": "4px",
	"hOneFontSize": "20px",
	"hTwoFontSize": "16px",
	"hThreeFontSize": "14px",
	"bFontSize": "16px",
	"mFontSize": "14px",
	"labelFontSize": "12px",
	"aFontSize": "16px",
	"s0": "4px",
	"s1": "8px",
	"s2": "16px",
	"s3": "24px",
	"s4": "32px",
	"s5": "48px",
	"dashboardButtonWidth": "172px"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/styles/variables/global.css
// module id = 39
// module chunks = 23